import { render, staticRenderFns } from "./Gestionepriorita.vue?vue&type=template&id=76f3df22&"
import script from "./Gestionepriorita.vue?vue&type=script&lang=js&"
export * from "./Gestionepriorita.vue?vue&type=script&lang=js&"
import style0 from "./Gestionepriorita.vue?vue&type=style&index=0&id=76f3df22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports